

import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/infinitives-explanation';
const mainimage = '/Images/infinitives1.webp';


const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "infinitives" },
];

const Infinitives = () => (
  <GrammarPageLayout
    level="B1"
    title="Infinitives"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Infinitives Exercises"
    seoDescription="Master verbs followed by to + infinitive: decide, hope, plan, want. B2 level practice."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);



export default Infinitives;

